'use client'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { FC } from 'react'
import Text from './common/Text'

const HotelsLoadingAnimation: FC = () => {
	const t = useTranslations('Main')

	return (
		<div className="md:w-[450px] text-center mx-auto pb-4">
			<Image
				src="/images/animations/hotels-animation.gif"
				width={75}
				height={56}
				unoptimized
				alt="Hotels loading animation"
				className="inline-block"
			/>

			<Text tag="h4" font="semibold" size="lg">
				{t('loadingAnimationText')}
			</Text>
		</div>
	)
}

export default HotelsLoadingAnimation
